	export function addItemToCart() {
		return (dispatch, getstate, firebase) => new Promise(function (resolve, reject) {
       console.log('hi')
		})
	}